import moment from 'moment';
import sanitizeHtml from 'sanitize-html';
import format from 'string-format';

export const formatRawAppointments = (rawData) => {
  const yearSymbol = 'y';
  const monthSymbol = 'm';
  const rawModel = rawData || [];
  if (rawModel.length < 1) {
    return [];
  }
  format.extend(String.prototype, {
    comma: (comp) => (comp.trim() ? comp + ',' : comp),
    newline: (comp) => (comp.trim() ? comp + '<br />' : comp),
  });

  const sanitizeHtmlConfig = {
    allowedTags: ['br'],
    allowedAttributes: [],
  };

  // Remove the last character if matches the param.
  const removeLastChar = (source, char) => {
    let result = source;
    const lastChar = source.slice(-1);
    if (lastChar === char) {
      result = source.slice(0, -1);
    }
    return result;
  };

  const splitDuration = (duration) => {
    const result = {};
    if (!duration) {
      return result;
    }
    let symbol = null;
    let symbolIndex = duration.indexOf(yearSymbol);
    if (symbolIndex < 0) {
      symbolIndex = duration.indexOf(monthSymbol);
      if (symbolIndex >= 0) {
        symbol = monthSymbol;
      }
    } else {
      symbol = yearSymbol;
    }
    if (symbolIndex < 0 || !symbol) {
      return {};
    }
    result[symbol] = parseInt(duration.substring(0, symbolIndex), 10);
    return result;
  };

  const getFollowupParts = (appt) => {
    let result = {};
    if (!appt || !appt.followUpLabel) {
      return result;
    }
    const parts = appt.followUpLabel.split('/');
    if (parts && parts.length) {
      parts.forEach((part) => {
        result = { ...result, ...splitDuration(part) };
        return true;
      });
    }
    return result;
  };

  const hasTimePart = (dateTime) => dateTime.format('h:mm:ss') !== '12:00:00';

  const mappedAppointments = rawModel.map((appointment) => {
    const mapped = {};
    mapped.id = appointment.externalAppointmentId || appointment.databaseId;
    mapped.status = appointment.status;
    mapped.hasTimePart = appointment.scheduledTime ?
      hasTimePart(moment(appointment.scheduledTime)) :
      hasTimePart(moment(appointment.startDate || appointment.targetDate));
    mapped.rawDate = appointment.scheduledTime ?
      appointment.scheduledTime :
      appointment.startDate || appointment.targetDate;

    mapped.date = mapped.rawDate;

    mapped.type = appointment.subtype || appointment.type;
    mapped.upcomingAppointmentType = appointment.upcomingAppointmentType;
    mapped.externalAppointmentType = appointment.externalAppointmentType;
    mapped.linkedToOtherTypeDatabaseId = appointment.linkedToOtherTypeDatabaseId;
    mapped.followUpLabel = appointment.followUpLabel;
    mapped.followUpLabelParts = getFollowupParts(appointment);

    mapped.provider = (!appointment.providerFirstName ? '' : appointment.providerFirstName) + ' ' +
      (!appointment.providerLastName ? '' : appointment.providerLastName);
    mapped.location = sanitizeHtml(
      (!appointment.locationDetail || appointment.locationDetail.trim() === '' ? '' :
        appointment.locationDetail + '<br/>') +
      (!appointment.institutionName || appointment.institutionName.trim() === '' ? '' :
        appointment.institutionName + '<br/>') +
      (!appointment.address1 || appointment.address1.trim() === '' ? '' : appointment.address1 + '<br/>') +
      (!appointment.address2 || appointment.address2.trim() === '' ? '' : appointment.address2 + '<br/>') +
      (!appointment.address3 || appointment.address3.trim() === '' ? '' : appointment.address3 + '<br/>') +
      (!appointment.city || appointment.city.trim() === '' ? '' : appointment.city + ',') + ' ' +
      (!appointment.provinceState || appointment.provinceState.trim() === '' ? '' : appointment.provinceState) + ' ' +
      (!appointment.postalZip || appointment.postalZip.trim() === '' ? '' : appointment.postalZip + '<br/>') +
      (!appointment.country || appointment.country.trim() === '' ? '' : appointment.country), sanitizeHtmlConfig
    );
    mapped.shortLocation = removeLastChar(sanitizeHtml(
      (!appointment.locationDetail || appointment.locationDetail.trim() === '' ? '' :
        appointment.locationDetail + '<br/>') +
      (!appointment.institutionName || appointment.institutionName.trim() === '' ? '' :
        appointment.institutionName + '<br/>') +
      (!appointment.address1 || appointment.address1.trim() === '' ? '' : appointment.address1 + ',') + ' ' +
      (!appointment.address2 || appointment.address2.trim() === '' ? '' : appointment.address2 + ',') + ' ' +
      (!appointment.address3 || appointment.address3.trim() === '' ? '' : appointment.address3 + ',') + ' ' +
      (!appointment.city || appointment.city.trim() === '' ? '' : appointment.city + ',') + ' ' +
      (!appointment.provinceState || appointment.provinceState.trim() === '' ? '' : appointment.provinceState),
      sanitizeHtmlConfig
    ).trim(), ',');
    mapped.microsoftTimeZone = appointment.microsoftTimeZone;
    mapped.timeZoneAbbreviation = appointment.timeZoneAbbreviation;
    mapped.linkedToOtherTypeCount = appointment.linkedToOtherTypeCount || 0;
    return mapped;
  });

  return mappedAppointments;
};
